export const GET_PRIMEUR_HEADER = 'GET_PRIMEUR_HEADER';
export const GET_PRIMEUR_LIVE = 'GET_PRIMEUR_LIVE';
export const GET_PRIMEUR_RECAP = 'GET_PRIMEUR_RECAP';
export const GET_PRIMEUR_PREPA = 'GET_PRIMEUR_PREPA';
